/// <amd-module name="VSSUI/Header" />
export { CustomHeader } from "./Components/Header/CustomHeader";
export { Header } from "./Components/Header/Header";
export { HeaderBackButton } from "./Components/Header/HeaderBackButton";
export { HeaderDescription } from "./Components/Header/HeaderDescription";
export { HeaderIcon } from "./Components/Header/HeaderIcon";
export { HeaderTitle } from "./Components/Header/HeaderTitle";
export { HeaderTitleArea } from "./Components/Header/HeaderTitleArea";
export { HeaderTitleRow } from "./Components/Header/HeaderTitleRow";

export {
    ICustomHeaderProps,
    IHeader,
    IHeaderBackButtonProps,
    IHeaderBreakpoint,
    IHeaderBreakpointCommandItem,
    IHeaderProps,
    IHeaderDescriptionProps,
    IHeaderIconProps,
    IHeaderTitleProps,
    IHeaderTitleAreaProps,
    IHeaderTitleRowProps,
    TitleSize
} from "./Components/Header/Header.Props";
